//------------------------------------------------------------------------------
// This file is auto-generated.
//------------------------------------------------------------------------------
// This file was generated by NTypewriter from the C# ViewModel class with the
// same class/interface name.
//
// Do not change this file.  Any changes may cause incorrect behaviour and will
// be lost if the code is regenerated.
//------------------------------------------------------------------------------

import { ItemBase } from '../internal/ItemBase';
import { TeacherPayrollSettingsUpdateItem } from './TeacherPayrollSettingsUpdateItem';
import { EventColorEnum, BillingProfileDefaultMode } from './Enums';

export class TeacherPrivilegesAndSettingsUpdateItem extends ItemBase {
    CanEditExpensesAndRevenue: boolean = false;
    CanEditInvoicesAndAccounts: boolean = false;
    CanEditMileage: boolean = false;
    CanEditOtherTeacherSchedulesAndStudents: boolean = false;
    CanEditOwnSchedule: boolean = false;
    CanEditReports: boolean = false;
    CanEditSharedOnlineResources: boolean = false;
    CanEditWebsiteAndPostNews: boolean = false;
    CanRecordPaymentWithAttendance: boolean = false;
    CanTakeAttendance: boolean = false;
    CanViewOtherTeacherSchedules: boolean = false;
    CanViewOtherTeacherContactInformation: boolean = false;
    CanViewOwnPayroll: boolean = false;
    CanViewStudentAndParentAddressAndTelephone: boolean = false;
    CanViewStudentAndParentEmailAddresses: boolean = false;
    CanViewStudentAttachments: boolean = false;
    IsAdministrator: boolean = false;
    IsActive?: boolean;
    IsTeacher?: boolean;
    ColorOnCalendar?: EventColorEnum;
    PreferredLessonEventLocationID?: string | null;
    ShowInSignUpDropDown?: boolean;
    DefaultBillingMode?: BillingProfileDefaultMode;
    DefaultEventCategoryID?: string | null;
    DefaultLessonDuration?: number;
    DefaultLessonPrice?: number;
    BookingPriority?: number;
    PayrollSettings?: TeacherPayrollSettingsUpdateItem | null;

    constructor(initializer?: Partial<TeacherPrivilegesAndSettingsUpdateItem>) {
        super();
        if (initializer) {
            Object.assign(this, initializer);
        }
    }

    static readonly ClassName: string = "TeacherPrivilegesAndSettingsUpdateItem";
}
